// Importing symbol-observable fixes a redux warning.
// More details: https://github.com/reduxjs/redux-toolkit/issues/2008
import { createRoot } from "react-dom/client";

import technicalProblemsImage from "@shared/images/robot-technical.webp";

import App from "./App";
import { unregister } from "./registerServiceWorker";

import "@fortawesome/fontawesome-free/css/all.css";
import "react-toastify/dist/ReactToastify.css";
import "./styles/global.css";

import "symbol-observable";
import "./i18n/config";

new Image().src = technicalProblemsImage;

const rootElement = document.getElementById("root");
if (!rootElement) {
    throw new Error("Root element #root not found. Make sure index.html includes <div id='root'></div>.");
}

const root = createRoot(rootElement);
root.render(<App />);

unregister();
